import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Connects to data-controller="sort"
export default class extends Controller {
  static targets = ["positionInput"];

  connect() {
    new Sortable(this.element, {
      handle: ".handle",
      animation: 150,
      easing: "cubic-bezier(1, 0, 0, 1)",
      onUpdate: this.onUpdate,
    });
  }

  onUpdate = (event) => {
    const newPosition = event.newIndex + 1;
    const itemId = event.item.id;
    const associatedPositionInput = this.positionInputTargets.find(
      (input) => input.dataset.id === itemId,
    );
    associatedPositionInput.value = newPosition;
    associatedPositionInput.form.requestSubmit();
  };
}
